import React, { useEffect, useReducer } from 'react';
import useSkipUpdate from '../../../../hooks/useSkipRender';
import SetResponsibleAdminView from '../view/SetResponsibleAdminView';

const SetResponsibleAdminReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'update':
      return { ...state, ...payload };

    case 'update_root':
      return { ...state, root: { ...state.root, ...payload } };
    default:
      return state;
  }
};

const SetResponsibleAdminEngine = ({ update = d => d, variant, ...props }) => {
  const [data, dispatch] = useReducer(SetResponsibleAdminReducer, {
    root: {
      emailTemplateId:
        (
          props.mailTemplates.find(
            temp => temp.code === 'assigned_to_review_submission'
          ) || {}
        ).id || '00000000-0000-0000-0000-000000000011'
    }
  });
  const { shouldSkipUpdate, skipUpdate } = useSkipUpdate();

  useEffect(() => {
    if (shouldSkipUpdate()) {
      return;
    }
    update({ additionalParameters: { root: data.root } });
  }, [data]);

  useEffect(() => {
    const root = props.additionalParameters && props.additionalParameters.root;
    if (!root) {
      return;
    }

    skipUpdate();
    dispatch({ type: 'update_root', payload: { ...root } });
  }, []);

  const viewProps = {
    ...props,
    variant,
    update,
    templateId: data.root.emailTemplateId,
    adminValue: data.root.assigneeId,
    setTemplateId: tId =>
      dispatch({ type: 'update_root', payload: { emailTemplateId: tId } }),
    updateRoot: root => dispatch({ type: 'update_root', payload: root })
  };

  return <SetResponsibleAdminView {...viewProps} />;
};

export default SetResponsibleAdminEngine;
